(function() {
  class AlProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.track = null;
      this.prevBtn = null;
      this.nextBtn = null;
      this.observer = null;
      this.isLoading = false;
    }

    connectedCallback() {
      const url = this.dataset.url;

      if (!url) return;

      if (this.querySelector('.al-recommendations-track')) {
        this.initCarousel();
        return;
      }

      if (!('IntersectionObserver' in window)) {
        this.loadRecommendations(url);
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;

        this.observer.disconnect();
        this.observer = null;
        this.loadRecommendations(url);
      }, { rootMargin: '600px 0px' });

      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (!this.observer) return;

      this.observer.disconnect();
      this.observer = null;
    }

    loadRecommendations(url) {
      if (this.isLoading) return;

      this.isLoading = true;

      fetch(url)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newContent = doc.querySelector('al-product-recommendations');

          if (!newContent) {
            this.style.display = 'none';
            return;
          }

          const trackWrapper = newContent.querySelector('.al-recommendations-track-wrapper');
          const currentTrackWrapper = this.querySelector('.al-recommendations-track-wrapper');

          if (!trackWrapper || !currentTrackWrapper) {
            this.style.display = 'none';
            return;
          }

          currentTrackWrapper.innerHTML = trackWrapper.innerHTML;
          this.initCarousel();
        })
        .catch(() => {
          this.style.display = 'none';
        });
    }

    initCarousel() {
      this.track = this.querySelector('.al-recommendations-track');
      this.prevBtn = this.querySelector('.al-recommendations-prev');
      this.nextBtn = this.querySelector('.al-recommendations-next');

      if (!this.track || !this.prevBtn || !this.nextBtn) return;

      this.prevBtn.addEventListener('click', () => this.scroll(-1));
      this.nextBtn.addEventListener('click', () => this.scroll(1));

      this.track.addEventListener('scroll', () => this.updateButtons());
      this.updateButtons();
    }

    scroll(direction) {
      if (!this.track) return;

      const scrollAmount = Math.min(this.track.clientWidth * 0.8, 520);
      this.track.scrollBy({
        left: direction * scrollAmount,
        behavior: 'smooth'
      });
    }

    updateButtons() {
      if (!this.track || !this.prevBtn || !this.nextBtn) return;

      const isAtStart = this.track.scrollLeft <= 1;
      const isAtEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 1;

      this.prevBtn.disabled = isAtStart;
      this.nextBtn.disabled = isAtEnd;
    }
  }

  if (!customElements.get('al-product-recommendations')) {
    customElements.define('al-product-recommendations', AlProductRecommendations);
  }
})();
